export default __webpack_public_path__ + "static/media/sico_shoot_landscape.4460e7cd.jpg";